import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { map, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ConfiguracionDePagoDTO } from 'src/app/pago/dtos/ConfiguracionDePagoDTO.model';
import { EstadoPagoDTO } from 'src/app/pago/dtos/EstadoPagoDTO';
import { PagoDTO } from 'src/app/pago/dtos/PagoDTO';
import { ConfiguracionDePagoFactory } from 'src/app/pago/factories/configuracion-de-pago/configuracion-de-pago.factory';
import { EstadoPagoFactory } from 'src/app/pago/factories/estado-pago/estado-pago.factory';
import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { Pago } from 'src/app/pago/models/Pago.model';
import { ResponsePagoOtroMedioDePago } from 'src/app/pago/models/ResponseOtroMedioDePago.model';
import { getProductNameHeader } from 'src/app/shared/utils/httpClientHeaders.utils';
import { retryRequest } from 'src/app/shared/utils/retryRequest.utils';

@Injectable({
  providedIn: 'root',
})
export class PagoService {
  private product: string;

  set productName(product: string) {
    this.product = product;
  }

  constructor(
    private httpClient: HttpClient,
    private pagoFactory: ConfiguracionDePagoFactory,
    private estadoPagoFactory: EstadoPagoFactory
  ) {}

  getPago(idPago: string): Observable<ConfiguracionDePago> {
    return this.httpClient
      .get<ConfiguracionDePagoDTO>(
        `${environment.pagosApi}/${idPago}/producto/config`,
        getProductNameHeader(this.product)
      )
      .pipe(
        map((response: ConfiguracionDePagoDTO) =>
          this.pagoFactory.convertToModel(response)
        ),
        retry({
          count: 1,
          delay: (error: HttpErrorResponse) => this.notifier$(error),
        })
      );
  }

  registerPago(idPago: string, pago: PagoDTO): Observable<ConfiguracionDePago> {
    return this.httpClient
      .post<ConfiguracionDePagoDTO>(
        `${environment.pagosApi}/producto/${idPago}/pago`,
        pago,
        getProductNameHeader(this.product)
      )
      .pipe(
        map((response: ConfiguracionDePagoDTO) =>
          this.pagoFactory.convertToModel(response)
        ),
        retry({
          count: 1,
          delay: (error: HttpErrorResponse) => this.notifier$(error),
        })
      );
  }

  getEstadoPago(idPago: string): Observable<Pago> {
    return this.httpClient
      .get<EstadoPagoDTO>(
        `${environment.pagosApi}/${idPago}/estado`,
        getProductNameHeader(this.product)
      )
      .pipe(
        map((response: EstadoPagoDTO) => {
          return this.estadoPagoFactory.convertToModel(response);
        })
      );
  }

  registerOtroMedioDePago(pago: Pago): Observable<string> {
    return this.httpClient
      .post<ResponsePagoOtroMedioDePago>(
        `${environment.pagosApi}/redireccion`,
        pago,
        getProductNameHeader(this.product)
      )
      .pipe(
        map((response: ResponsePagoOtroMedioDePago) => response.url),
        retry({
          count: 1,
          delay: (error: HttpErrorResponse) => this.notifier$(error),
        })
      );
  }

  private notifier$(error: HttpErrorResponse): Observable<unknown> {
    const retryReq = retryRequest(error);
    return retryReq ? timer(3000) : throwError(() => error);
  }
}
